const rawSiteUrl = import.meta.env.VITE_SITE_URL as string | undefined;

export const SITE_URL = (rawSiteUrl || 'https://allchinabuyspread.de').replace(/\/+$/, '');
export const SITE_NAME = 'AllChinaBuy Spreadsheet';
export const SITE_TAGLINE =
  'Your trusted AllChinaBuy spreadsheet resource hub with product finds, buying guides, reviews, and shipping information.';
export const SITE_LOGO =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png';